import { render, staticRenderFns } from "./ProductImageThumbnail.vue?vue&type=template&id=9638f576&scoped=true"
import script from "./ProductImageThumbnail.vue?vue&type=script&lang=js"
export * from "./ProductImageThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ProductImageThumbnail.vue?vue&type=style&index=0&id=9638f576&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9638f576",
  null
  
)

export default component.exports